export enum QwLanguageKeys {
  ar = 'ar-MA',
  bg = 'bg-BG',
  ca = 'ca-ES',
  zh = 'zh-CN',
  hr = 'hr-HR',
  cs = 'cs-CZ',
  da = 'da-DK',
  nl = 'nl-NL',
  en = 'en-US',
  et = 'et-EE',
  fi = 'fi-FI',
  fr = 'fr-FR',
  de = 'de-DE',
  el = 'el-GR',
  he = 'he-IL',
  hu = 'hu-HU',
  is = 'is-IS',
  id = 'id-ID',
  it = 'it-IT',
  ja = 'ja-JP',
  ko = 'ko-KR',
  lv = 'lv-LV',
  lt = 'lt-LT',
  ms = 'ms-MY',
  nb = 'nb-NO',
  pl = 'pl-PL',
  pt = 'pt-PT',
  ro = 'ro-RO',
  ru = 'ru-RU',
  sr = 'sr-Latn-RS',
  sk = 'sk-SK',
  sl = 'sl-SI',
  es = 'es-ES',
  sv = 'sv-SE',
  th = 'th-TH',
  tr = 'tr-TR',
  uk = 'uk-UA',
  vi = 'vi-VN',
}

type QwLabelKeys = keyof typeof QwLabelFallback;

export type QwLabels = {
  [L in QwLabelKeys]: string;
};

export const QwLabelFallback = {
  add: 'Add',
  all: 'All',
  addAnotherRoom: 'Add another room',
  addToCart: 'Add to cart',
  addedToYourCart: 'Added to your cart',
  adults: 'Adults',
  adult: 'Adult',
  amenities: 'Amenities',
  andThe: 'and the',
  arrival: 'Arrival',
  available: 'Available',
  availablePlural: 'Available',
  averagePerNight: 'Average per night',
  backToRoomList: 'Back to room list',
  beds: 'beds',
  bed: 'bed',
  beforeExtrasAddRooms: 'Before choosing extras, please add rooms to basket.',
  bestPrices: 'Best prices',
  bookingConditions: 'Booking & Sales Conditions',
  bookNow: 'Book now',
  bookThisOffer: 'Book this offer',
  breakfast: 'Breakfast',
  cancellationPolicy: 'Cancellation Policy',
  cancellationInsurance: 'Cancellation Insurance',
  cancellationInsuranceQuestion:
    'Do you want to subscribe the Cancellation Insurance for',
  cancellationInsuranceAcceptance:
    'By clicking on "yes" you acknowledge that you have read and accept the insurance summary in addition to the sales terms and conditions for cancellation insurance',
  cancellationInsuranceTermsAndConditions:
    'Sales terms and conditions for Cancellation Insurance',
  cancellationInsuranceSummary: 'Insurance summary',
  changeDates: 'Change dates',
  checkAvailability: 'Check Availability',
  checkInTime: 'Check-in time',
  checkout: 'Checkout',
  children: 'Children',
  child: 'Child',
  chooseRoomType: 'Choose room type',
  cityTaxesNotIncluded: 'City taxes (not included)',
  clickHere: 'Click here',
  confirmation: 'Confirmation',
  confirm: 'Confirm',
  confirmationAndAgreement: 'and confirm that I agree and understand them.',
  continue: 'Continue',
  continueBE: 'Continue',
  contacts: 'Contacts',
  country: 'Country of residence',
  day: 'Day',
  dates: 'Dates',
  departure: 'Departure',
  deposit: 'Deposit',
  email: 'Email',
  emailCaption: 'This is the email we will send your confirmation to',
  emptyBasket: 'Empty basket',
  equipments: 'Equipments',
  extras: 'Extras',
  femaleDorm: 'Female dorm',
  femaleOnlyRoom: 'Female only dorm',
  filterBy: 'Filter by',
  firstName: 'First Name',
  freeCancellation: 'Free cancellation',
  fromYearsOld: 'From 18 years old',
  guest: 'Guest',
  guests: 'Guests',
  guestsMustBe18yrsOrOlder: 'Guests must be 18yrs or older',
  hideRooms: 'Hide rooms',
  iHaveRead: 'I have read the',
  infants: 'Infants',
  informationRequest:
    'I’d like to receive information from your property and the Clink Hostels brand',
  lastName: 'Last Name',
  maximum: 'Maximum',
  mixedDorm: 'Mixed dorm',
  moreInformation: 'More information',
  missingRequiredFields: '* Missing some required fields',
  nights: 'Nights',
  numberOfRooms: 'Number of rooms',
  numberOfGuests: 'Number of guests',
  no: 'No',
  noSufficientRooms: 'No sufficient rooms for your guests',
  noExtraInYourBasket: 'No extra in your basket',
  noRatesForSelectedOccupancy:
    'No rates for the selected Occupancy, please choose another one.',
  noRooms: 'No rooms',
  noAvailabilityRooms:
    'There is no availability for the stay dates you have requested. Please, change your dates, choose another room or clean the basket.',
  noDormSelectable:
    'There is no availability for shared rooms because there are children or infants in your booking session',
  noPromoAvailable: 'Sorry, it seems that the Promo is not available anymore',
  noThanks: 'No Thanks',
  oneOrMoreGuestNeedsToBeAccommodated:
    'One or more guests need to be accommodated',
  or: 'or',
  otherDates: 'Other dates',
  otherInfo: 'Other info',
  over18: 'Over 18',
  payNow: 'Pay now',
  perNight: 'per night',
  person: 'Person',
  people: 'People',
  phone: 'Phone number',
  phoneCaption: 'We will use this for urgent communications',
  proceedToCheckout: 'Proceed to checkout',
  promoCodeAdded: 'Promo Code added',
  promoCodeHere: 'Promo code here',
  promoCodeRemoved: 'Promo Code removed',
  pricesFor: 'Prices for',
  privacyPolicy: 'Privacy policy',
  privateRoom: 'Private room',
  quantity: 'Quantity',
  quoteErrorMessage: 'The basket rooms could not welcome all guests',
  rate: 'Rate',
  redirectionPayment:
    'You will be redirected to our secure site to enter your payment information',
  removeFromCart: 'Remove',
  reset: 'Reset',
  resetCartForPromoCode: 'promo code and reset the cart',
  room: 'Room',
  rooms: 'Rooms',
  roomDetails: 'room details',
  roomListCardErrorMessage:
    'This room is not available fot the dates/guests selected, or the rate is not available with the one in your basket',
  roomQuantity: 'Room qty',
  salesTermsAndConditions: 'Sales terms and conditions',
  specificSalesConditions: 'Specific sales conditions',
  saveTimeAtCheckIn: 'Save time at check-in',
  secureTransaction: 'Secure transaction',
  service: 'Service',
  sharedRoom: 'Shared dorm',
  showRooms: 'Show rooms',
  specialOffer: 'Special Offer',
  specialRequest: 'Special requests',
  specialRequestMessage:
    'Tell us if you need any special services or special requests',
  startingFrom: 'starting from',
  subtotal: 'Subtotal',
  under18: 'Under 18',
  updateSession: 'Update',
  upgradeYourStay: 'Upgrade your stay',
  upToYearsOld: 'Up to 17 years old',
  taxesExcludedInRoom: 'Taxes excluded in the room price',
  taxesIncludedInRoom: 'Taxes added to the price of the room',
  taxesaddedInRoom: 'Taxes added to the price of the room',
  termsAndConditionMessage:
    'I have read and agree with the terms & conditions and booking conditions for my stay',
  title: 'Title',
  today: 'Today',
  tomorrow: 'Tomorrow',
  total: 'Total',
  totalFor: 'Total for',
  typeOf: 'Type of',
  viewRoom: 'View room',
  viewAllRates: 'View all rates',
  viewMore: 'View more',
  vatIncluded: 'VAT included',
  vatExcluded: 'VAT excluded',
  yes: 'Yes',
  yourBookingDetails: 'Your booking details',
  yourCartIsEmpty: 'Your cart is empty',
  yourRooms: 'Your rooms',
  rateInvalid: 'Rates for this rooms are invalid',
  rateInvalidDescription:
    'We apologize for the inconvenience, please click the button below to continue with your booking',
  rateProceed: 'Proceed',
  resetCartWarning: 'by proceeding with the payment your cart will be reset.',
  selectQuantity: 'Select Q.ty',
  updateQuantity: 'Update Q.ty',
  updateRoomPrices: 'to update rooms prices with',
  mandatoryFields: 'Mandatory field',
  mandatoryInfo: 'All information marked with (*) is required',
  blindsOnLowerBunkbeds: 'Blinds on lower bunkbeds',
  chooseDestination: 'Choose destination',
  pleaseSelect: 'Please select',
  roomType: 'Room type',
  insertPromoCode: 'Insert promo code',
  apply: 'Apply',
  attention: 'Attention!',
  removePromoCodeAlert: 'Removing the promocode will reset your cart.',
  doYouWantToProced: 'Do you want to proceed?',
  keepit: 'No, keep it',
  iamsure: 'Yes, I am sure',
  yourBooking: 'Your booking',
  updateYourSearch: 'Update your search',
  updateYourSearchAlert:
    'Updating the search will reset everything and launch a new booking session.',
  chooseYourExtras: 'Choose your extras',
  checkoutInfo: 'Checkout info',
  yourSearch: 'Your search',
  edit: 'Edit',
  chooseDates: 'Choose dates',
  allRoomTypes: 'All room types',
  allTypes: 'All types',
  allRooms: 'All rooms',
  destination: 'Destination',
  destinations: 'Destinations',
  promoCode: 'Promo code',
  chooseYourAccommodation: 'Choose your accommodation',
  cart: 'Cart',
  groupsOfFifteen: 'Groups of 15+',
  invalidPromoCode: 'Invalid Promo Code',
  clickHereGroups: 'Click Here',
  dormGuestsMustBe18yrsOrOlder: 'Dorm guests must be 18yrs or older',
  lessInfo: 'Less information',
  close: 'Close',
  sharedBathroom: 'Shared bathroom',
  prmAdapted: 'PRM adapted (on demand)',
  privateRooms: 'Private rooms',
  sharedDorms: 'Shared dorms',
  femaleOnlyDorms: 'Female only dorms',
  backToRoomAlert:
    'If you go back to the room list, your selection will be deleted.',
  excludedTaxes: 'Excluded taxes',
  halfBoard: 'Halfboard',
  extraNotAvailable: 'Extras not available for this stay',
  creditCard: 'Credit card',
  infoCreditCard:
    'A valid credit card will be required on arrival as a guarantee.',
  //CLINK
  whoIs: "Who's",
  sleepWhere: 'Sleeping where',
  forYourInfo: 'For your information',
  guestDetails: 'Add Guest details',
  bookSalesConditions: 'Booking & Sales Condition',
  out: 'out',
  stay: 'stay',
  minStay: 'Minimum stay',
  nightsTwo: '2 nights',
  night: 'night',
  hideDetails: 'Hide Details ',
  noChargeValidation:
    'You will not be charged. This step validates your reservation',
  girlsDorms: 'Girls dorms',
  securePayment: '100% Secure Payment', //to check % symbol
  applied: 'Applied',
  book: 'Book',
  checkIn: 'Check-in',
  checkOut: 'Check-out',
  dorm: 'Dorm',
  dorms: 'Dorms',
  finalization: 'Finalization',
  girlsDorm: 'Girls dorm',
  guest18accompanied: 'Guests must be 18+ unless accompanied by an adult',
  howMany: 'How many',
  marketingUpdates:
    "I'd like to occasionally receive marketing updates from Clink.", //to check ' symbol
  invalid: 'Invalid',
  max: 'Max',
  perDay: 'per day',
  perPerson: 'per person',
  pod: 'Pod',
  rateConditions: 'Rate Conditions',
  viewDetails: 'View details',
  noCharge: 'You will not be charged. This step validates your reservation',
  stayTaxes: 'Stay taxes (not included)',
  chooseRate: 'Choose a rate',
  enhanceYourStay: 'Enhance your stay',
  justAsYouWish: 'Your stay your way',
  amsterdam: 'Amsterdam',
  london: 'London',
  dublin: 'Dublin',
  yourStayYourWay: 'Your stay, your way',
  groupsOfTen: 'Groups of 10+',
  addedToTheBasket: 'Added to the basket',
  bookingSalesConditions: 'Booking & Sales Conditions',
  femaleDorms: 'Female dorms',
  contactInformation: 'Contact Information',
  privacyConsent: 'Privacy & Consent',
  search: 'Search',
  gotPromo: 'Got a promo?',
  yourbookingSelection: 'Your booking selection',
  pleaseCheckRequiredFields: 'Please check required fields',
  pleaseAccommodateAllGuests: 'Please accommodate all guests',
  only: 'only',
  required: 'required',
  whereAreYouGoing: 'Where to?',
  nationality: 'Nationality',
  groupsOfTwenty: 'Groups of 20+',
  maxGuest: 'Max 8 guests on this property',
} as const;

const getTranslation = (key: QwLabelKeys) => {
  return window.QW_HOTEL_ENV.LABELS?.[key] || QwLabelFallback[key];
};

export const getLanguageFromLocalStorage = () =>
  localStorage.getItem('lang_js');

export const getLanguageKeyFromLocalStorage = () => {
  const langInLocalStorage = getLanguageFromLocalStorage();
  if (!langInLocalStorage) {
    return null;
  }
  return QwLanguageKeys[langInLocalStorage as keyof typeof QwLanguageKeys];
};

export const getLanguageFromSessionStorage = () =>
  sessionStorage.getItem('lang_js');

export const getLanguageKeyFromSessionStorage = () => {
  const langInSessionStorage = getLanguageFromSessionStorage();
  if (!langInSessionStorage) {
    return null;
  }
  return QwLanguageKeys[langInSessionStorage as keyof typeof QwLanguageKeys];
};

export const Language = { getTranslation };
